<template>
  <div>
    <el-card style="margin-bottom: 25px;border: none;box-shadow: none;"
      :class="isShow ? 'show_card' : 'show_card header-border'">
      <div slot="header" style="display: flex; justify-content:space-between;cursor: pointer" @click="changeShow">
        <span style="font-weight: bold;font-size: 14px;color: #636569">信息解释</span>
        <i class="el-icon-arrow-up" v-show="isShow"
          style="cursor: pointer;color: #1e6cb0;font-weight: bold;font-size: 14px;" title="展开介绍">折叠</i>
        <i class="el-icon-arrow-down" v-show="!isShow"
          style="cursor: pointer;color: #1e6cb0;font-weight: bold;font-size: 14px;" title="折叠介绍">展开</i>
      </div>
      <el-descriptions v-show="isShow" style="margin-bottom: 0;font-size: 13px!important;" border :column="3"
        :labelStyle="{ width: '126px' }">
        <el-descriptions-item label="文件自动同步" :span="3">
          该数据从share服务器获取，每3小时同步一次
        </el-descriptions-item>
      </el-descriptions>
    </el-card>
    <el-tabs v-model="activeName" @tab-click="changeTab">
      <!--      <el-tab-pane name="扩增子测序" label="扩增子测序"></el-tab-pane>-->
      <!--      <el-tab-pane name="二代测序" label="二代测序"></el-tab-pane>-->
      <!--      <el-tab-pane name="三代测序" label="三代测序"></el-tab-pane>-->
      <!--      <el-tab-pane name="蛋白代谢组测序" label="蛋白代谢组测序"></el-tab-pane>-->
      <el-tab-pane name="自动生成合同模板" label="自动生成合同模板"></el-tab-pane>
      <el-tab-pane name="其他" label="其他"></el-tab-pane>
      <el-tab-pane name="更新日志" label="更新日志"></el-tab-pane>
    </el-tabs>
    <el-tabs v-if="activeName==='扩增子测序'" v-model="AMPLICONActiveName" @tab-click="changeTab">
      <el-tab-pane name="二代" label="二代"></el-tab-pane>
      <el-tab-pane name="三代" label="三代"></el-tab-pane>
    </el-tabs>
    <el-tabs v-if="['二代测序','三代测序'].includes(activeName)" v-model="NGSTGGActiveName" @tab-click="changeTab">
      <el-tab-pane name="DNA" label="DNA"></el-tab-pane>
      <el-tab-pane name="EPI" label="EPI"></el-tab-pane>
      <el-tab-pane name="META" label="META"></el-tab-pane>
      <el-tab-pane name="RNA" label="RNA"></el-tab-pane>
    </el-tabs>
    <el-tabs v-if="activeName==='蛋白代谢组测序'" v-model="METAPROActiveName" @tab-click="changeTab">
      <el-tab-pane name="代谢" label="代谢"></el-tab-pane>
      <el-tab-pane name="蛋白" label="蛋白"></el-tab-pane>
    </el-tabs>
    <el-tabs v-if="activeName==='其他'" v-model="PCRActiveName" @tab-click="changeTab">
      <!--      <el-tab-pane name="荧光定量" label="荧光定量"></el-tab-pane>-->
      <el-tab-pane name="三代测序" label="三代测序"></el-tab-pane>
      <el-tab-pane name="二代测序" label="二代测序"></el-tab-pane>
      <el-tab-pane name="扩增子测序" label="扩增子测序"></el-tab-pane>
      <el-tab-pane name="蛋白代谢组测序" label="蛋白代谢组测序"></el-tab-pane>
      <el-tab-pane name="菌检" label="菌检"></el-tab-pane>
      <el-tab-pane name="理化性质" label="理化性质"></el-tab-pane>
      <el-tab-pane name="其他" label="其他"></el-tab-pane>
    </el-tabs>
    <el-timeline v-if="activeName==='更新日志'">
      <el-timeline-item :color="item.size === 'large' ? '#409EFF': '#e4e7ed'" :size="item.size"
        :timestamp="item.updateTime" placement="top" v-for="(item,index) in logData" :key="index">
        <el-card>
          <h4 v-if="item['updateContent'] && item['updateContent'].length > 0">更新内容:</h4>
          <ul>
            <li class="logDetail" v-for="(itemInner,index) in item['updateContent']"><i
                class="iconfont icon-dian"></i>{{ itemInner }}
            </li>
          </ul>
        </el-card>
      </el-timeline-item>
    </el-timeline>
    <w-table ref="wMyTable" :columns="columns" :table-data="tableData" v-if="activeName === '其他'"
      @getTableSearchSortCon="getTableSearchSortCon" :isPagination="true" :page="page"
      @pageChange="handlePagePagination">
      <div slot="operation" slot-scope="{record}">
        <el-link type="primary" icon="el-icon-download" @click="download(record)">{{ record.contractFileName
          }}</el-link>
      </div>
      <div slot="contractName" slot-scope="{text,record,index,column}">
        <w-ellipsis-and-look :text="text" :column="column"></w-ellipsis-and-look>
      </div>
    </w-table>
    <add-new-template v-if="activeName === '自动生成合同模板'"></add-new-template>
    <!--    图片加载-->
    <picture-loading v-if="loading"></picture-loading>
  </div>
</template>

<script>

import PictureLoading from "@/components/customerTable/PictureLoading";
import { getTemplatePage} from "@/api/dilivery/template";
import {template} from "@/utils/data/tableCol/template/template";
import {getMethodLog} from "@/api/dilivery/method";
import AddNewTemplate from "@/views/systems/Template/AddNewTemplate.vue";
import {getDataInLocalStorage} from "@/utils/localStorage";

const baseURL = process.env.VUE_APP_BASE_API
export default {
  name: "Template",
  components: {
    AddNewTemplate,
    PictureLoading,
  },
  data() {
    return {
      isShow:true,
      logData:[],
      tableData: [],
      // 分页参数
      page: {
        currentNum: 1,
        pageSize: 10,
        total: 0
      },
      sortConditionTag: [],
      searchConditionTag: [],
      loading: false,
      activeName: '自动生成合同模板',
      AMPLICONActiveName: '二代',
      NGSTGGActiveName: 'DNA',
      METAPROActiveName: '代谢',
      PCRActiveName: '三代测序'
    }
  },
  computed: {
    columns() {
      return JSON.parse(JSON.stringify(template([] || {})))
    }
  },
  created() {
    // this.getData()
  },
  methods: {
    changeShow() {
      this.isShow = !this.isShow
    },
    changeTab(tab, event) {
      if(this.activeName !== '更新日志'){
        this.getData(true)
      }else{
        this.getLogData()
      }
    },
    //获取报告模板更新日志
    getLogData() {
      this.loading = true
      let params = {
        updateLogType: 'CONTRACT_LOG',
      };
      getMethodLog(params).then(res => {
        this.loading = false
        if (res.code === 200) {
          this.logData = res.data.map(item => {
            return {
              ...item,
              size:'large'
            }
          })
        }
      }).catch(err => { this.loading = false })
    },
    //获取报告模板数据列表
    getData(isResetPageCurrent) {
      this.loading = true
      let params = {
        'page.current': this.page.currentNum,
        'page.size': this.page.pageSize,
      };
      if (isResetPageCurrent) {
        params = {
          'page.current': 1,
          'page.size': 10,
        }
      }
      let name;
      switch (this.activeName) {
        case '扩增子测序':
          name = this.AMPLICONActiveName
          break;
        case '二代测序':
          name = this.NGSTGGActiveName
          break;
        case '三代测序':
          name = this.NGSTGGActiveName
          break;
        case '蛋白代谢组测序':
          name = this.METAPROActiveName
          break;
        case '其他':
          name = this.PCRActiveName
          break;
        default:
          name = this.AMPLICONActiveName
          break;
      }
      let sendData = {
        "projectClassification": this.activeName,
        "projectSubcategories": name
      }
      if (this.sortConditionTag.length > 0) {
        params["order"] = this.sortConditionTag.map(sortCondition => {
          return sortCondition.colName + "." + sortCondition.order;
        }).join(",");
      }
      if (this.searchConditionTag && this.searchConditionTag.length) {
        //遍历搜索条件的内容
        sendData = this.getSearch(sendData)
      }
      getTemplatePage(params, sendData).then(res => {
        if (res.code === 200) {
          this.tableData = res.data.records.map((itemA, index) => {
            return {
              ...itemA,
              id: (parseInt(res.data.current) - 1) * parseInt(res.data.size) + index
            }
          })
          // 分页赋值
          this.page.currentNum = parseInt(res.data.current)
          this.page.pageSize = parseInt(res.data.size)
          this.page.total = parseInt(res.data.total)
        }
        this.loading = false
      }).catch(err => {
        this.loading = false
      }
      )
    },
    getSearch(sendData) {
      let data = {...sendData}
      this.searchConditionTag.forEach(item => {
        let key = item.key
        data[key] = item.value
      })
      return data
    },
    //获取表格搜索条件
    getTableSearchSortCon(searchConditionTag, sortConditionTag) {
      this.searchConditionTag = searchConditionTag
      this.sortConditionTag = sortConditionTag
      this.getData(true)
    },
    //分页
    handlePagePagination(page) {
      this.page.currentNum = page.currentNum
      this.page.pageSize = page.pageSize
      this.getData()
    },
    //下载模板
    async download(row) {
      try {
        let url = `${baseURL}/contract-template/download/${row.hexCode}/${getDataInLocalStorage("token")}`
        const elink = document.createElement('a')
        elink.href = url
        document.body.appendChild(elink)
        elink.click()
        document.body.removeChild(elink);
      } catch (error) {
        console.log(error);
      }
    },
  }
}
</script>

<style scoped>
</style>
